module.exports = __webpack_public_path__ + "img/s14.3a1c552.png";